import React from "react";
import Autocomplete from "react-autocomplete";
import { useTranslation } from "react-i18next";

const SearchFormComponent = ({
  onSubmit,
  autocompletedSuggestions,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <form
      onSubmit={(e) => {
        onSubmit(e);
      }}
    >
      <div className="u-form">
        <Autocomplete
          inputProps={{ type: "text", name: "fullsearch" }}
          wrapperStyle={{ display: "block", position: "relative" }}
          renderInput={(props) => (
            <div className="u-form-search u-mg--auto j-input">
              {/* <label htmlFor="product-search">{t("例：G3VM-101DR")}</label> */}
              <input {...props} placeholder={t("e.g.：G3VM-101DR")} />
              <button type="submit" />
            </div>
          )}
          menuStyle={{
            borderRadius: "3px",
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
            background: "rgba(255, 255, 255, 0.9)",
            padding: "2px 0",
            fontSize: "90%",
            position: "absolute",
            overflow: "auto",
            left: "0",
            top: "52",
          }}
          getItemValue={(item) => item.suggestion}
          items={autocompletedSuggestions.documents || []}
          renderItem={(item, isHighlighted) => (
            <div
              key={item.suggestion}
              style={{
                background: isHighlighted ? "#005eb8" : "white",
                color: isHighlighted ? "white" : "#005eb8",
                padding: "1rem",
                translations: "all 0.5s ease",
              }}
            >
              {item.suggestion}
            </div>
          )}
          renderMenu={function (items, value, style) {
            return (
              <div
                style={{ ...style, ...this.menuStyle, padding: "0px" }}
                children={items}
              />
            );
          }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onSelect={(val) => {
            onChange(val);
            setTimeout(() => {
              onSubmit({ preventDefault: () => {} });
            }, 10);
          }}
        />
      </div>
    </form>
  );
};

export default SearchFormComponent;
